var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "navigation",
    class: {
      'animated': _vm.pageReady
    }
  }, _vm._l((_vm.menu), function(li, key) {
    return (li.full_path !== '/' && _vm.isShown(li) && li.parent_id === _vm.parent) ? _c('li', {
      class: {
        'selected': _vm.isCurrent(li.path)
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
          _vm.scrollTo(li.path)
        }
      }
    }, [_c('span', [_c('router-link', {
      style: (("animation-delay: " + ((key * 100)/1000) + "s")),
      attrs: {
        "to": ("/" + (li.path))
      }
    }, [_vm._v(_vm._s(li.name))])], 1), _vm._v(" "), (_vm.keyFinder(_vm.menu, li.object_id)) ? _c('ul', _vm._l((_vm.getSubLists(_vm.menu, li)), function(subli, key2) {
      return _c('li', {
        on: {
          "click": function($event) {
            _vm.setCurrentTab(subli.path)
          }
        }
      }, [_c('span', {
        style: (("animation-delay: " + ((key2 * 70)/1000) + "s"))
      }, [_vm._v(_vm._s(subli.name))])])
    })) : _vm._e()]) : _vm._e()
  }))
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-12cc574c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/NavigationMenu.vue
// module id = 182
// module chunks = 0